<template>
  <div class="donate-page">
    <!-- 顶部 Banner -->
    <div class="header-section">
      <div class="banner-bg">
        <div class="banner-deco deco-1"></div>
        <div class="banner-deco deco-2"></div>
        <div class="banner-deco deco-3"></div>
        <div class="banner-content">
          <div class="badge-wrapper">
            <img :src="require('@/assets/badge.png')" alt="校徽" />
          </div>
          <div class="banner-text">
            <h2 class="banner-title">爱心捐赠</h2>
            <p class="banner-subtitle">您的每一份爱心都将助力永春一中发展</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 表单卡片 -->
    <div class="form-wrapper">
      <!-- 捐赠金额卡片 -->
      <div class="form-card">
        <div class="card-header">
          <div class="header-title">
            <div class="title-badge">
              <van-icon name="balance-o" />
            </div>
            <span class="title-text">选择捐赠金额</span>
            <span class="required-tag">必填</span>
          </div>
        </div>
        <div class="amount-options">
          <div v-for="amt in presetAmounts" :key="amt" class="amount-item"
            :class="{ active: selectedAmount === amt && !isCustom }" @click="selectAmount(amt)">
            <span class="amount-value">￥{{ amt }}</span>
          </div>
          <div class="amount-item custom" :class="{ active: isCustom }" @click="selectCustom">
            <span class="amount-value">自定义金额</span>
          </div>
        </div>
        <div v-if="isCustom" class="custom-input-wrapper">
          <div class="custom-input-box">
            <span class="input-prefix">￥</span>
            <van-field v-model="customAmount" type="number" placeholder="请输入金额" class="custom-amount-field"
              input-align="left" />
          </div>
        </div>
      </div>

      <!-- 捐赠人信息卡片 -->
      <div class="form-card info-card">
        <div class="form-item">
          <div class="form-label">
            <span class="required-star">*</span>
            捐赠人（如填实名即默认愿意公开捐赠信息）
          </div>
          <van-field v-model="form.name" placeholder="请填写" class="info-field" />
        </div>

        <div class="form-item">
          <div class="form-label">
            <span class="required-star">*</span>
            手机号
          </div>
          <van-field v-model="form.phone" type="tel" placeholder="请填写" maxlength="11" class="info-field" />
        </div>

        <div class="form-item">
          <div class="form-label">
            届别（非一中校友的爱心人士可填单位名称或不填）
          </div>
          <van-field v-model="form.grade" placeholder="毕业年份(如高中15届)或单位名称" class="info-field" />
        </div>

        <div class="form-item">
          <div class="form-label">
            班级（非一中校友的爱心人士不必填）
          </div>
          <van-field v-model="form.className" placeholder="即就读班级（如1班）" class="info-field" />
        </div>

        <div class="form-item remark-item">
          <div class="form-label">
            寄语&捐赠项目备注
          </div>
          <van-field v-model="form.remark" rows="2" autosize type="textarea" placeholder="自愿填写" maxlength="100"
            show-word-limit class="info-field remark-field" />
        </div>
      </div>

    </div>

    <!-- 捐赠金额预览卡片 -->
    <div class="amount-preview-card" :class="{ 'has-amount': finalAmount > 0 }">
      <div class="preview-icon">
        <van-icon name="gift-card-o" />
      </div>
      <div class="preview-content">
        <span class="preview-label">本次捐赠</span>
        <div class="preview-amount">
          <span class="amount-symbol">￥</span>
          <span class="amount-number">{{ finalAmount || '0' }}</span>
        </div>
      </div>
    </div>

    <!-- 底部安全区域 -->
    <div class="bottom-safe-area"></div>

    <!-- 底部确认栏 -->
    <div class="bottom-bar">
      <div class="amount-display" @click="scrollToTop">
        <span class="display-label">捐赠金额</span>
        <span class="display-unit">￥</span>
        <span class="display-value">{{ finalAmount }}</span>
        <van-icon name="arrow-up" class="scroll-icon" />
      </div>
      <div class="submit-btn" :class="{ disabled: !canSubmit }" @click="handleSubmit">
        <van-icon name="bag-o" class="btn-icon" />
        确认捐赠
      </div>
    </div>
  </div>
</template>

<script>
/* global WeixinJSBridge */
import request from '@/utils/request';

export default {
  name: 'DonatePage',
  data() {
    return {
      presetAmounts: [100, 300, 500, 800, 1000],
      selectedAmount: 100,
      isCustom: false,
      customAmount: '',
      form: {
        name: '',
        phone: '',
        grade: '',
        className: '',
        remark: '',
      },
    };
  },
  created() {},
  computed: {
    finalAmount() {
      if (this.isCustom) {
        return this.customAmount ? parseFloat(this.customAmount) : 0;
      }
      return this.selectedAmount;
    },
    canSubmit() {
      return (
        this.finalAmount > 0 &&
        this.form.phone &&
        /^1\d{10}$/.test(this.form.phone)
      );
    },
  },
  methods: {
    selectAmount(amt) {
      this.selectedAmount = amt;
      this.isCustom = false;
      this.customAmount = '';
    },
    selectCustom() {
      this.isCustom = true;
      this.selectedAmount = 0;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    async handleSubmit() {
      if (!this.canSubmit) {
        if (this.finalAmount <= 0) {
          this.$toast('请选择或输入捐赠金额');
          return;
        }
        if (!this.form.phone || !/^1\d{10}$/.test(this.form.phone)) {
          this.$toast('请输入正确的手机号');
          return;
        }
        return;
      }

      const submitData = {
        amount: this.finalAmount,
        name: this.form.name || '匿名用户',
        phone: this.form.phone,
        grade: this.form.grade,
        className: this.form.className,
        remark: this.form.remark,
      };

      try {
        const res = await request.post('/app/donation/order', submitData);
        if (res.code === 200 || res.code === 0) {
          const payParams = res.data && res.data.payParams ? res.data.payParams : {};
          if (!payParams || !payParams.appId) {
            this.$toast('获取支付参数失败');
            return;
          }
          this.callWechatPay(payParams);
        } else {
          this.$toast(res.msg || '创建订单失败');
        }
      } catch (err) {
        this.$toast(err.msg || '提交失败，请稍后重试');
      }
    },
    callWechatPay(params) {
      const payConfig = {
        appId: params.appId,
        timeStamp: params.timeStamp || params.timestamp,
        nonceStr: params.nonceStr || params.noncestr,
        package: params.package || params.packageValue,
        signType: params.signType || 'RSA',
        paySign: params.paySign || params.paysign,
      };

      if (typeof WeixinJSBridge !== 'undefined') {
        WeixinJSBridge.invoke('getBrandWCPayRequest', payConfig, (res) => {
          if (res.err_msg === 'get_brand_wcpay_request:ok') {
            this.$toast('支付成功');
            this.$router.replace('/home');
          } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
            this.$toast('支付已取消');
          } else {
            this.$toast('支付失败：' + res.err_msg);
          }
        });
      } else {
        // 非微信环境提示
        this.$toast('请在微信浏览器中完成支付');
      }
    },
  },
};
</script>

<style lang="less" scoped>
// 设计 Token
@primary: #8b1a2b;
@primary-light: #b83245;
@primary-dark: #6b1321;
@gold: #c9a96e;
@gold-light: #dcc696;
@bg: #faf7f2;
@card-bg: #ffffff;
@text-primary: #2c1810;
@text-secondary: #6b5b50;
@text-tertiary: #9b8b7b;
@border: #ede5dc;
@input-border: #eeeeee;
@red: #e53935;
@shadow: 0 4px 20px rgba(44, 24, 16, 0.06);

.donate-page {
  min-height: 100vh;
  background: @bg;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}

// ========== 顶部装饰区域 ==========
.header-section {
  position: relative;

  .banner-bg {
    position: relative;
    width: 100%;
    height: 150px;
    background: linear-gradient(
      180deg,
      #a83e4f 0%,
      @primary 60%,
      @primary-dark 100%
    );
    overflow: hidden;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding-bottom: 32px;

    .banner-deco {
      position: absolute;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.06);
      pointer-events: none;
    }

    .deco-1 {
      width: 120px;
      height: 120px;
      top: -30px;
      right: -20px;
      background: rgba(255, 255, 255, 0.08);
    }

    .deco-2 {
      width: 80px;
      height: 80px;
      top: 20px;
      right: 60px;
      background: rgba(255, 255, 255, 0.05);
    }

    .deco-3 {
      width: 160px;
      height: 160px;
      bottom: -60px;
      left: -40px;
      background: rgba(255, 255, 255, 0.04);
    }

    .banner-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      z-index: 1;

      .badge-wrapper {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.95);
        padding: 3px;
        box-shadow: 0 3px 12px rgba(0, 0, 0, 0.2);
        margin-bottom: 12px;

        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          object-fit: cover;
        }
      }

      .banner-text {
        text-align: center;

        .banner-title {
          font-size: 22px;
          font-weight: 800;
          color: #fff;
          margin: 0 0 5px;
          letter-spacing: 4px;
          text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
        }

        .banner-subtitle {
          font-size: 12px;
          color: rgba(255, 255, 255, 0.85);
          margin: 0;
          letter-spacing: 2px;
        }
      }
    }
  }
}

// ========== 表单卡片容器 ==========
.form-wrapper {
  margin: -30px 16px 0;
  position: relative;
  z-index: 2;
}

// ========== 表单卡片基础样式 ==========
.form-card {
  background: @card-bg;
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: @shadow;

  .card-header {
    margin-bottom: 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid @border;

    .header-title {
      display: flex;
      align-items: center;

      .title-badge {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        background: linear-gradient(135deg, @gold-light, @gold);
        border-radius: 8px;
        margin-right: 10px;
        color: #fff;
        font-size: 14px;
      }

      .title-text {
        font-size: 16px;
        font-weight: 700;
        color: @text-primary;
      }

      .required-tag {
        margin-left: auto;
        font-size: 11px;
        color: @primary;
        background: rgba(139, 26, 43, 0.08);
        padding: 2px 8px;
        border-radius: 10px;
        font-weight: 500;
      }
    }
  }
}

// ========== 金额选项 ==========
.amount-options {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;

  .amount-item {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    text-align: center;
    background: @bg;
    border: 1px solid @border;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.25s;
    user-select: none;

    .amount-value {
      font-size: 14px;
      font-weight: 600;
      color: @text-primary;
    }

    &:active {
      transform: scale(0.96);
    }

    &.active {
      background: linear-gradient(135deg, @primary-light, @primary);
      border-color: @primary;
      box-shadow: 0 3px 10px rgba(139, 26, 43, 0.22);

      .amount-value {
        color: #fff;
      }
    }

    &.custom {
      .amount-value {
        font-size: 13px;
      }
    }
  }
}

.custom-input-wrapper {
  margin-top: 10px;

  .custom-input-box {
    display: flex;
    align-items: center;
    background: @bg;
    border: 1px solid @border;
    border-radius: 10px;
    padding: 4px 12px;
    transition: border-color 0.2s;

    &:focus-within {
      border-color: @primary;
    }

    .input-prefix {
      font-size: 16px;
      font-weight: 600;
      color: @primary;
      margin-right: 4px;
    }

    .custom-amount-field {
      flex: 1;
      background: transparent;
      padding: 6px 0;

      /deep/ .van-field__control {
        font-size: 15px;
        font-weight: 600;
        color: @text-primary;
      }
    }
  }
}

// ========== 信息卡片 ==========
.info-card {
  background: @card-bg;
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: @shadow;
}

// ========== 表单项 ==========
.form-item {
  padding: 12px 0;
  border-bottom: 1px solid @input-border;

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }

  &.remark-item {
    .form-label {
      margin-bottom: 8px;
    }
  }

  .form-label {
    display: flex;
    align-items: flex-start;
    font-size: 15px;
    font-weight: 500;
    color: @text-primary;
    margin-bottom: 8px;
    line-height: 1.4;

    .required-star {
      color: @red;
      margin-right: 4px;
    }
  }

  /deep/ .van-cell {
    background: @card-bg;
    border: 1px solid @input-border;
    border-radius: 8px;
    padding: 10px 12px;

    &::after {
      display: none;
    }

    .van-field__control {
      font-size: 15px;
      color: @text-primary;
    }

    .van-field__control::placeholder {
      color: @text-tertiary;
      font-size: 14px;
    }
  }

  .info-field {
    /deep/ .van-cell {
      background: @card-bg;
      border: 1px solid @input-border;
    }
  }

  .remark-field {
    /deep/ .van-field__word-limit {
      margin-top: 6px;
      font-size: 11px;
      color: @text-tertiary;
    }
  }
}

// ========== 金额预览卡片 ==========
.amount-preview-card {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  background: linear-gradient(135deg, #f5f5f5, #ebebeb);
  border-radius: 16px;
  margin: 0 16px 12px;
  transition: all 0.3s;

  &.has-amount {
    background: linear-gradient(135deg, @primary, @primary-dark);
    box-shadow: 0 6px 24px rgba(139, 26, 43, 0.3);
  }

  .preview-icon {
    width: 44px;
    height: 44px;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 14px;

    .van-icon {
      font-size: 22px;
      color: #fff;
    }
  }

  .preview-content {
    flex: 1;

    .preview-label {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.7);
      display: block;
      margin-bottom: 4px;
    }

    .preview-amount {
      display: flex;
      align-items: baseline;

      .amount-symbol {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.8);
      }

      .amount-number {
        font-size: 28px;
        font-weight: 800;
        color: #fff;
        font-family: 'DIN Alternate', 'Helvetica Neue', Arial, sans-serif;
      }
    }
  }
}

// ========== 底部安全区域 ==========
.bottom-safe-area {
  height: 80px;
}

// ========== 底部确认栏 ==========
.bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px calc(10px + constant(safe-area-inset-bottom));
  padding: 10px 16px calc(10px + env(safe-area-inset-bottom));
  background: #fff;
  border-top: 1px solid @border;
  box-shadow: 0 -4px 20px rgba(44, 24, 16, 0.06);
  z-index: 100;

  .amount-display {
    display: flex;
    align-items: center;
    cursor: pointer;

    .display-label {
      font-size: 13px;
      color: @text-secondary;
      margin-right: 4px;
    }

    .display-unit {
      font-size: 14px;
      color: @primary;
      font-weight: 600;
    }

    .display-value {
      font-size: 22px;
      font-weight: 800;
      color: @primary;
      font-family: 'DIN Alternate', 'Helvetica Neue', Arial, sans-serif;
      letter-spacing: 1px;
    }

    .scroll-icon {
      font-size: 12px;
      color: @text-tertiary;
      margin-left: 6px;
    }
  }

  .submit-btn {
    min-width: 150px;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, @primary-light, @primary);
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    border-radius: 23px;
    cursor: pointer;
    transition: all 0.15s;
    box-shadow: 0 4px 14px rgba(139, 26, 43, 0.35);
    letter-spacing: 1px;

    .btn-icon {
      font-size: 18px;
      margin-right: 6px;
    }

    &:active {
      transform: scale(0.97);
      background: linear-gradient(135deg, @primary, @primary-dark);
    }

    &.disabled {
      background: #ccc;
      box-shadow: none;
      cursor: not-allowed;

      &:active {
        transform: none;
      }
    }
  }
}
</style>
